import BenchMarkTable from '@/pages/benchmark/components/BenchMarkTable';
import MetricConfig from '@/pages/benchmark/components/MetricConfig';
import OperationTitle from '@/pages/benchmark/components/OperationTitle';
import TabsAndRadio from '@/pages/benchmark/components/TabsAndRadio';
import CommonHeader from '@/pages/benchmark/components/CommonHeader';
import PageWrapContainer from '@/pages/benchmark/components/PageWrapContainer';
import CommonContantWrap from '@/pages/dashboard/components/PageContainer/CommonContantWrap';

export default {
  BenchMarkTable,
  TabsAndRadio,
  MetricConfig,
  CommonHeader,
  PageWrapContainer,
  CommonContantWrap,
  OperationTitle
};
